import Articles from './containers/Articles';

export default Articles;
